import { UsuarioEffects } from './usuario.effects';

export const effectsArr: any[] = [ UsuarioEffects ];
export * from './usuario.effects';
